/**
 * API origin for Axios and the home screen footer.
 * Dev (`npm start`) uses REACT_APP_BASE_API_URL_DEV; production (`npm run build`) uses REACT_APP_BASE_API_URL_PROD.
 * Both are set in `.env` (Create React App inlines `REACT_APP_*` at build time).
 */
export const API_BASE_URL =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_BASE_API_URL_PROD
    : process.env.REACT_APP_BASE_API_URL_DEV;
